<template>
    <div v-if="amount > 0" class="hidden-mobile">
        <div class="holidays-to-approve">
          <heading colour="white" size="medium" no-margin>Holidays To Approve</heading>
          <p>There are holiday requests to approve for {{ amount }} Employee/s.</p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                amount: 0
            };
        },
        computed: {},
        watch: {},
        methods: {
            getUnapprovedHolidays(){
                var that = this;

                axios.get(appUrls.holidays.unapproved)
                    .then(response => {
                        that.amount = response.data.data.length;
                    });
            }
        },
        mounted() {
            this.getUnapprovedHolidays();
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon{
        background-color: $brand;
    }
    .holidays-to-approve {
        @include clearfix();
        background-color: $brand;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: $brand;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #dcefff;
            }
        }
    }
</style>
